import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

export default function Deposits() {
  const token = localStorage.getItem("adminToken");

  const [deposits, setDeposits] = useState([]);

  useEffect(() => {
    loadDeposits();
  }, []);

  async function loadDeposits() {
    try {
      const res = await fetch("/api/admin/deposits", {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      const json = await res.json();

      setDeposits(Array.isArray(json) ? json : json.deposits || []);
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div
      style={{
        display: "flex",
        background: "#f3f4f6",
        minHeight: "100vh",
      }}
    >
      <Sidebar />

      <div style={{ flex: 1 }}>
        <Header />

        <div style={{ padding: 25 }}>
          <h2>Deposit History</h2>

          <table
            width="100%"
            cellPadding="10"
            style={{
              background: "#fff",
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr
                style={{
                  background: "#2563eb",
                  color: "#fff",
                }}
              >
                <th>User ID</th>
                <th>Amount</th>
                <th>Hash</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>
              {deposits.map((item) => (
                <tr key={item._id}>
                  <td>{item.userId}</td>

                  <td>{Number(item.amount || 0).toFixed(2)} USDT</td>

                  <td style={{ maxWidth: 250, wordBreak: "break-all" }}>
                    {item.txHash ? (
                      <a
                        href={`https://bscscan.com/tx/${item.txHash}`}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          color: "#2563eb",
                          fontWeight: "bold",
                          textDecoration: "none",
                        }}
                      >
                        View Hash
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>

                  <td>
                    <span
                      style={{
                        color:
                          item.status === "confirmed" ||
                          item.status === "forwarded"
                            ? "green"
                            : item.status === "failed" ||
                              item.status === "Rejected"
                            ? "red"
                            : "orange",
                        fontWeight: "bold",
                      }}
                    >
                      {item.status}
                    </span>
                  </td>

                  <td>
                    {item.createdAt
                      ? new Date(item.createdAt).toLocaleString()
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
